<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_first_contact_intro')
}

const isOnDiplomacySection = computed(() => {
  return route.path.startsWith('/diplomacy/overview')
})

const goToDiplomacy = () => {
  router.push('/diplomacy/overview')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        We have just met another civilization!
      </p>
      <p class="pb-2">
        Lets go to the Diplomacy section to see what we know about them so far.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Click on the "Diplomacy" button in the top menu.
      </Alert>
      <Alert type="info" class="md:hidden">
        Tap on the "menu" and then the "Diplomacy" item
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnDiplomacySection" @click="goToDiplomacy" class="mr-2">
        Go to Diplomacy
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Done!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>